<template>
  <div class="promotions">
    <ion-toolbar color="primary">
      <ion-title class="ion-text-center h-f-b">News</ion-title>
    </ion-toolbar>

    <div class="promotions-carousel ion-padding-vertical">
      <carousel
        :autoplay="true"
        :autoplay-timeout="3000"
        :loop="true"
        :per-page="1"
        :center-mode="true"
        :pagination-padding="5"
        pagination-active-color="#FF0082"
        pagination-color="#838688"
      >
        <slide v-for="(offer, index) in offers" v-bind:key="index">
          <div class="promotion">
            <ion-card>
              <img v-bind:src="offer.image" />
              <ion-card-header>
                <ion-card-title class="h-f-b">{{ offer.title }}</ion-card-title>
                <ion-card-subtitle>{{ offer.description }}</ion-card-subtitle>
              </ion-card-header>
            </ion-card>
          </div>
        </slide>
      </carousel>
    </div>
    <!-- /.promotions-carousel -->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "offers-slider",
  props: {
    offers: { type: Array },
  },
  components: {
    carousel: Carousel,
    slide: Slide,
  },
};
</script>

<style scoped>
.promotions-carousel {
  background: var(--ion-color-dark);
}

.promotion {
  width: 100%;
}

ion-card {
  position: relative;
  text-align: center;
}

ion-card-header {
  position: absolute;
  bottom: 0%;
  width: 100%;
}

ion-card-title,
ion-card-subtitle {
  color: #fff;
}
</style>
